import { cx } from "../../styled-system/css";
import { styles } from "../styles";

type Props = {
  registered: boolean;
  disabled?: boolean;
  label: string;
  onClick: () => void;
};

export function QrRegistrationButton(props: Props) {
  return (
    <button
      class={cx(styles.qrRegistrationButton, props.registered && styles.qrRegistrationButtonRegistered)}
      type="button"
      title={props.label}
      aria-label={props.label}
      aria-pressed={props.registered}
      disabled={props.disabled}
      onClick={props.onClick}
    >{props.registered ? "QR" : "未"}</button>
  );
}
